import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function e() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var _i = 0, _Object$entries = Object.entries(n); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        i = _Object$entries$_i[0],
        o = _Object$entries$_i[1];

    f(t, s(r, i), o);
  }

  return t;
}

function s(n, r) {
  return n ? n + "[" + r + "]" : r;
}

function f(n, r, t) {
  if (Array.isArray(t)) {
    var _iterator = _createForOfIteratorHelper(t.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            i = _step$value[0],
            o = _step$value[1];

        f(n, s(r, i.toString()), o);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else t instanceof Date ? n.push([r, t.toISOString()]) : typeof t == "boolean" ? n.push([r, t ? "1" : "0"]) : typeof t == "string" ? n.push([r, t]) : typeof t == "number" ? n.push([r, "".concat(t)]) : t == null ? n.push([r, ""]) : e(t, r, n);
}

function p(n) {
  var t;
  var r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");

  if (r) {
    var _iterator2 = _createForOfIteratorHelper(r.elements),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var i = _step2.value;

        if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
          i.click();
          return;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
}

export { p as attemptSubmit, e as objectToFormEntries };